<template>
	<div class="custom-partition" v-if="visible">
		<!--自定义分区列表-->
		<el-form-item>
			<el-table :data="partitionInfos"
				max-height="250">
				<!--挂载点-->
				<el-table-column
					key="point"
					:label="$t('retailInstance.text.mountpoints')">
					<template slot-scope="scope">
						<span v-if="!scope.row.isAdd">{{scope.row.point}}</span>
						<span v-else="scope.row.isAdd">
							<el-select
								v-model="scope.row.point"
								@change="(val) => pointChange(val,scope.row)"
								class="w100">
								<el-option v-for="item in oSMountPointsRest" :key="item.label"
									:value="item.value"></el-option>
							</el-select>
						</span>
					</template>
				</el-table-column>
				<!--容量-->
				<el-table-column
					key="size"
					:label="$t('retailInstance.text.capacity')">
					<template slot-scope="scope">
						<span v-show="!scope.row.isEditing">
							<span v-if="scope.row.isRemainDataPartition && hasRemainPartitions">
								{{$t('retailInstance.text.allRemainingSpace')}}
							</span>
							<span v-else>
								{{scope.row.size}}GiB
							</span>
						</span>
						<div v-show="scope.row.isEditing">
							<el-input-number class="w50" v-model="scope.row.size" @input.native="(val)=>sizeChange(val,scope)" :min="scope.row.minSize" :max="scope.row.maxSize" :controls="false"></el-input-number>
							<span>GiB</span>
						</div>
					</template>
				</el-table-column>
				<!--文件系统-->
				<el-table-column
					key="format"
					:label="$t('retailInstance.text.fileSystem')">
					<template slot-scope="scope">
						<el-select
							v-show="scope.row.isEditing"
							v-model="scope.row.format" class="w100">
							<el-option v-for="item in oSFileSystemFormats" :key="item.label"
								:value="item.value"></el-option>
						</el-select>
						<span v-show="!scope.row.isEditing">
							{{scope.row.format}}
						</span>
					</template>
				</el-table-column>
				<!--操作-->
				<el-table-column
					key="operation"
					:label="$t('listPage.tableLabel.operation')">
					<template slot-scope="scope">
						<!--保存-->
						<a href="javascript:void(0)" @click="savePartition(scope)"
							:class="{'operation': scope.row.isEditing}"
							v-if="scope.row.isEditing">
							{{$t('subnet.text.save')}}
						</a>
						<!--编辑-->
						<a href="javascript:void(0)" @click="editPartition(scope)"
							 :class="{'operation': scope.row.isEditing}"
							 v-if="!scope.row.isEditing && !scope.row.isNoPartition">
							{{$t('subnet.text.edit')}}
						</a>
						<!--删除-->
						<a href="javascript:void(0)" @click="deletePartition(scope)" v-if="scope.row.point !=='/' && !scope.row.isNoPartition">
							{{$t('subnet.text.delete')}}
						</a>
					</template>
				</el-table-column>
			</el-table>
		</el-form-item>
		<!--添加分区按钮-->
		<el-form-item>
			<el-tooltip
				:disabled="partitionRestNumber > 0"
				:content="$t('retailInstance.help.only5partitions',[partitionsMax])"
				placement="right">
				<a @click="addPartition"
					:class="{'cps-dropdown-disabled': partitionRestNumber <= 0 }">
					<i class="jc-icon-plus"></i>{{ $t('retailInstance.text.addPartition')}}
				</a>
			</el-tooltip>
			<span class="ml10">
				{{$t('subnet.help.moreAliasIpAvailablePart0')}}
			</span>
			<span class="highlight-font-color">{{partitionRestNumber}}</span>
			<span>
				{{$t('retailInstance.help.morePartitionPart2')}}
			</span>
		</el-form-item>
	</div>
</template>

<script>
let oSFileSystemFormats;
import { partitionsMaxConstant} from '@/common/Constants';
export default {
	data() {
		return {
			dialogVisible: this.visible,
			oSFileSystemFormats: [],
			oSMountPoints: [],
			hasRemainPartitions: true,
			isRowNotSaved: false
		};
	},
	model: {
		prop: 'partitionInfos',
		event: 'changePartitionInfos'
	},
	props: {
		// 系统盘 数据盘
		diskType: {
			type: String,
			default: 'system'
		},
		// 当前盘分区信息
		partitionInfos: {
			type: Array,
			default: []
		},
		// 其他盘分区信息
		otherPartitionInfos: {
			type: Array,
			default: []
		},
		totalDiskSize: {
			type: Number,
			default: 0
		},
		// 组件是否显示
		visible: {
			type: Boolean,
			default: false
		},
		region: {
			type: String,
			default: ''
		},
		isCentOS66: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		partitionRestNumber() {
			let partitionType = this.diskType;
			if (!this.noPartitionData) {
				return 0
			}
			let rest;
			if (partitionType === 'system') {
				rest = 5 - (this.partitionInfos.length -1);
			} else {
				rest = 3 - (this.partitionInfos.length -1);
			}
			rest = rest > 0 ? rest : 0;
			return Math.min(rest, this.oSMountPointsRest.length);
		},
		oSMountPointsRest() {
			let partitionInfosOSMountPoints = {};
			this.partitionInfos.map((item) => {
				partitionInfosOSMountPoints[item.point] = item.point;
			})
			let otherPartitionInfosOSMountPoints = {};
			this.otherPartitionInfos.map((item) => {
				otherPartitionInfosOSMountPoints[item.point] = item.point;
			})
			let oSMountPoints = this.oSMountPoints.filter(item => {
				return !(partitionInfosOSMountPoints[item.label]) && !(otherPartitionInfosOSMountPoints[item.label])
			});
			return oSMountPoints
		},
		noPartitionData() {
			return this.partitionInfos.filter((item) => {
				return item.isNoPartition
			}).reduce((total, current) => {
				return total + current.size
			},0);
		},
		partitionsMax() {
			let diskType = this.diskType;
			return partitionsMaxConstant[diskType]
		}
	},
	mounted() {
		this.getOSFileSystemFormats();
		this.getOSMountPoints();
	},
	watch: {
		visible(newVal) {
			if (!newVal) {
				this.isRowNotSaved = false;
			}
		},

		isCentOS66(newVal) {
			if (newVal) {
				this.oSFileSystemFormats = oSFileSystemFormats.filter(item => item.value !== 'xfs')
			} else {
				this.oSFileSystemFormats = oSFileSystemFormats;
			}
		}
	},
	methods: {
		addPartition() {
			if (!this.partitionRestNumber || this.isRowNotSaved) {
				return
			}
			this.isRowNotSaved = true;
			let partition = {
				point: "",
				isEditing: true,
				size: 40,
				format: this.isCentOS66 ? 'ext3' : 'xfs',
				isAdd: true,
				minSize: 0
			};
			let pos = this.partitionInfos.length-1;
			this.partitionInfos.splice(pos,0,partition);
			this.calPartitionMaxsize();
			//this.$emit('changePartitionInfos',this.partitionInfos);
		},
		// 删除当前行
		deletePartition(scope) {
			this.partitionInfos.splice(scope.$index, 1);
			this.calPartitionMaxsize();
			this.isRowNotSaved = false
		},
		// 保存当前行
		savePartition(scope) {
			if (!scope.row.point) {
				return
			}
			scope.row.isEditing = false;
			scope.row.isAdd = false;
			this.dealRemainPartitionsShow();
			this.calPartitionMaxsize();
			this.isRowNotSaved = false;
		},

		dealRemainPartitionsShow() {
			let remainSystemDataPartitions =  this.totalDiskSize - this.partitionInfos.filter(item => !item.isNoPartition).reduce((init,current) => {
				return init + current.size
			},0);
			// 特殊处理剩余全部空间展示文案
			if (remainSystemDataPartitions === 0) {
				this.hasRemainPartitions = true;
			} else {
				this.hasRemainPartitions = false;
			}
		},
		calPartitionMaxsize() {
			let remainSystemDataPartitions =  this.totalDiskSize - this.partitionInfos.filter(item => !item.isNoPartition).reduce((init,current) => {
				return init + current.size
			},0);
			this.partitionInfos.map(item => {
				if(item.isNoPartition) {
					item.size = remainSystemDataPartitions;
				}
				item.maxSize = item.size + remainSystemDataPartitions;
			})
		},

		// 编辑当前行
		editPartition(scope) {
			if (this.isRowNotSaved) {
				return
			}
			scope.row.isEditing = true;
			this.isRowNotSaved = true;
			if (scope.row.point === 'swap') {
				this.oSFileSystemFormats = oSFileSystemFormats.filter(item => item.value === 'swap')
			} else {
				if (this.isCentOS66) {
					this.oSFileSystemFormats = oSFileSystemFormats.filter(item => item.value !== 'xfs' && item.value !== 'swap')
				} else {
					this.oSFileSystemFormats = oSFileSystemFormats.filter(item => item.value !== 'swap')
				}
			}
		},

		sizeChange(val,scope) {
			clearTimeout(this.inputNumberTimeout);
			this.inputNumberTimeout = setTimeout(() => {
				let v = val.target.value;
                v = v.replace(/[^0-9]/ig, '');
				scope.row.size = v
			}, 600)
		},

		getOSFileSystemFormats() {

			const params = {
				region: this.region
			};
			Ajax.get('/api/cps/getOSFileSystemFormats', params)
			.then((res) => {
				oSFileSystemFormats = this.oSFileSystemFormats = res.data.formats.map(item => {
					return {
						label: item.toLocaleLowerCase(),
						value: item.toLocaleLowerCase(),
					}
				})
			})
			.catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
			});
		},

		getOSMountPoints() {
			const params = {
				region: this.region,
				volumeType: this.diskType,
			};
			Ajax.get('/api/cps/getOSMountPoints',params)
			.then((res) => {
				this.oSMountPoints = res.data.points.map(item => {
					return {
						label: item,
						value: item,
					}
				})
			})
			.catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
			});
		},

		pointChange(val, row) {
			if (val === 'swap') {
				this.oSFileSystemFormats = oSFileSystemFormats.filter(item => item.value === 'swap')
				row.format = 'swap';
			} else {
				if (this.isCentOS66) {
					this.oSFileSystemFormats = oSFileSystemFormats.filter(item => item.value !== 'xfs' && item.value !== 'swap')
					row.format = 'ext3';
				} else {
					this.oSFileSystemFormats = oSFileSystemFormats.filter(item => item.value !== 'swap')
					row.format = 'xfs';
				}
			}
			if (val === '/boot') {
				row.minSize = 1;
			}
		}
	}
};
</script>

<style lang="scss">
	.custom-partition {
        width: 830px;
		.a-disabled{
			color: #9e9e9e;
			cursor: not-allowed;
		}

		.cell {
			.w100 {
				width: 100px;
				vertical-align: middle;

			}
			.w50 {
				width: 50px;
				vertical-align: middle;

			}
		}

	}
</style>



// WEBPACK FOOTER //
// src/components/common/customPartition/customPartition.vue